
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class DocumentReportsGrid extends _Ext.GridBase<DocumentReportsRow, any> {
        protected getColumnsKey() { return 'Administration.DocumentReports'; }
        protected getDialogType() { return DocumentReportsDialog; }
        protected getIdProperty() { return DocumentReportsRow.idProperty; }
        protected getInsertPermission() { return DocumentReportsRow.insertPermission; }
        protected getLocalTextPrefix() { return DocumentReportsRow.localTextPrefix; }
        protected getService() { return DocumentReportsService.baseUrl; }

        constructor(container: JQuery, opt) {
            super(container, opt);
        }
    }
}